import { ListTitle } from "@ui/ListTitle";
import { Text } from "@ui/typography/Text";
import { createResource, For, Show } from "solid-js";
import {
	type DiscoveryCategory,
	listDiscoveryCategoryCreators,
} from "@/client";
import { CreatorCategoryCard } from "./CreatorCategoryCard";

type Props = {
	category: DiscoveryCategory;
};

const countLabel = (count: number) =>
	count === 1 ? "1 creator" : `${count} creators`;

export const CategoryCreators = (props: Props) => {
	const [creators] = createResource(
		() => [props.category.id] as const,
		async ([slug]) => {
			const res = await listDiscoveryCategoryCreators({
				path: { slug },
			});
			return res.data?.influencers ?? [];
		},
	);

	return (
		<section>
			<div class="askgvt-section-head">
				<ListTitle>Creators</ListTitle>
				<Show when={!creators.loading}>
					<Text as="span" size="small" color="fg3">
						{countLabel(creators()?.length ?? 0)}
					</Text>
				</Show>
			</div>
			<Show
				when={!creators.loading}
				fallback={
					<Text size="small" color="fg3">
						Loading creators…
					</Text>
				}
			>
				<div class="askgvt-creators askgvt-creators--category">
					<For each={creators() ?? []}>
						{(creator) => <CreatorCategoryCard creator={creator} />}
					</For>
				</div>
			</Show>
		</section>
	);
};
